/**
 * F03.3-T08/T09 Predictive search: fetch suggest, render dropdown, View all, keyboard.
 * F03.3-T09: debounce, abort, session cache (query → HTML), query normalize.
 * Lock-state: no member price when body has .is-member-locked (F03.3-T07).
 */
(function () {
  "use strict";

  var root = typeof window.Shopify !== "undefined" && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : "/";
  var suggestUrl = root.replace(/\/$/, "") + "/search/suggest.json";
  var CACHE_MAX = 20;
  var PREDICTIVE_IMAGE_MAX = 120;
  var cache = [];
  var cacheMap = {};
  var TAXONOMY_SHORTCUTS = [
    {
      key: "raw_dairy",
      label: "Raw Dairy",
      url: "/collections/raw-dairy",
      searchTerm: "milk",
      terms: ["milk", "mil", "raw dairy", "dairy", "diary", "cheese", "cheeses", "butter", "cream", "ghee"]
    },
    {
      key: "eggs",
      label: "Eggs",
      url: "/collections/eggs",
      searchTerm: "eggs",
      terms: ["egg", "eggs", "dozen", "dozens", "eg"]
    },
    {
      key: "meats",
      label: "Pastured Meats",
      url: "/collections/meats",
      searchTerm: "beef",
      terms: ["beef", "beaf", "steak", "steaks", "roast", "roasts", "ground beef", "meat", "meats"]
    },
    {
      key: "ferments",
      label: "Ferments & Cultured",
      url: "/collections/ferments",
      searchTerm: "fermented",
      terms: ["fermented", "ferment", "ferments", "cultured", "culture", "pickles", "pickle"]
    },
    {
      key: "pantry",
      label: "Pantry Staples",
      url: "/collections/pantry",
      searchTerm: "pantry",
      terms: ["pantry", "dry goods", "shelf stable", "shelf-stable", "shelfstable"]
    },
    {
      key: "producer_amos",
      label: "Amos Miller",
      url: "/pages/amos-miller",
      searchTerm: "Amos Miller",
      terms: ["amos", "amos miller", "founding producer", "producer"]
    }
  ];

  function resolveCanonicalSearchQuery(query) {
    var raw = (query || "").trim();
    if (!raw) return raw;
    var shortcuts = getTaxonomyShortcuts(raw);
    if (shortcuts.length) return shortcuts[0].searchTerm;
    var normalized = normalizeQuery(raw);
    if (normalized === "egg") return "eggs";
    if (normalized === "dozen" || normalized === "dozens") return "eggs";
    if (normalized === "diary") return "dairy";
    return raw;
  }

  function installSearchFormCanonicalization() {
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var input = form.querySelector('input[name="q"]');
        if (!input) return;
        var action = String(form.getAttribute("action") || "");
        if (action.indexOf("/search") < 0 && !form.closest("[data-pma-predictive-search]")) return;
        var canonical = resolveCanonicalSearchQuery(input.value);
        if (canonical && canonical !== input.value) input.value = canonical;
      },
      true,
    );
  }

  window.PMA = window.PMA || {};
  window.PMA.search = window.PMA.search || {};
  window.PMA.search.resolveCanonicalSearchQuery = resolveCanonicalSearchQuery;
  window.PMA.search.getTaxonomyShortcuts = getTaxonomyShortcuts;

  function cacheKey(q) {
    return (q || "").trim().toLowerCase();
  }

  function cacheGet(q) {
    var key = cacheKey(q);
    return cacheMap[key];
  }

  function cacheSet(q, html) {
    var key = cacheKey(q);
    if (cache.length >= CACHE_MAX && cacheMap[key] === undefined) {
      var old = cache.shift();
      delete cacheMap[old.key];
    }
    if (cacheMap[key] === undefined) {
      cache.push({ key: key, html: html });
      cacheMap[key] = html;
    } else {
      cacheMap[key] = html;
    }
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel), 0);
  }

  function escapeHtml(s) {
    if (s == null) return "";
    var div = document.createElement("div");
    div.textContent = s;
    return div.innerHTML;
  }

  function isMemberActive() {
    return document.body && document.body.classList.contains("is-member-active");
  }

  function normalizeQuery(q) {
    return (q || "")
      .toLowerCase()
      .replace(/[-_]+/g, " ")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getTaxonomyShortcuts(query) {
    var normalized = normalizeQuery(query);
    if (!normalized || normalized.length < 2) return [];

    return TAXONOMY_SHORTCUTS.filter(function (shortcut) {
      return shortcut.terms.some(function (term) {
        var normalizedTerm = normalizeQuery(term);
        return normalized.indexOf(normalizedTerm) >= 0 ||
          (normalized.length >= 3 && normalizedTerm.indexOf(normalized) === 0);
      });
    }).slice(0, 4);
  }

  function capShopifyImageWidth(url, maxWidth) {
    if (!url) return "";
    var w = maxWidth || PREDICTIVE_IMAGE_MAX;
    if (url.indexOf("width=") !== -1) {
      return url.replace(/([?&]width=)\d+/i, "$1" + w);
    }
    return url.replace(/_(\d+)x(\d+)?(?=\.(jpe?g|png|webp|gif))/i, "_" + w + "x$2");
  }

  function publicProducerLabel(vendor) {
    var raw = String(vendor || "").trim();
    if (!raw) return "Association Producer";
    var down = raw.toLowerCase();
    var shopDown = String((window.Shopify && window.Shopify.shop) || "").replace(/\.myshopify\.com$/i, "").replace(/-/g, " ").toLowerCase();
    if (
      down === "amish products association" ||
      down === "apa" ||
      down === "amish products" ||
      (shopDown && down === shopDown)
    ) {
      return "Association Producer";
    }
    return raw;
  }

  function buildProductHtml(p, placeholderUrl) {
    var url = p.url || "#";
    var title = escapeHtml(p.title || "");
    var producerLabel = escapeHtml(publicProducerLabel(p.vendor));
    var producerMissing = producerLabel === "Association Producer";
    var imgSrc = p.featured_image || placeholderUrl || "";
    imgSrc = capShopifyImageWidth(imgSrc, PREDICTIVE_IMAGE_MAX);
    var img = imgSrc
      ? "<img src=\"" + escapeHtml(imgSrc) + "\" alt=\"" + title + "\" width=\"60\" height=\"75\" loading=\"lazy\" decoding=\"async\">"
      : "";
    var priceHtml = isMemberActive() && p.price
      ? "<span class=\"pma-predictive-product-card__price\">" + escapeHtml(p.price) + "</span>"
      : "<span class=\"pma-predictive-product-card__locked\">" + (window.PMA && window.PMA.i18n && window.PMA.i18n.locked_price_label || "Member Price") + "</span>";
    var producerAttrs = ' data-producer-attribution data-context="predictive"' +
      (producerMissing ? ' data-pma-qa-producer-followup="required" data-producer-source="association-fallback"' : "");
    return (
      "<article class=\"pma-predictive-product-card pma-predictive-product-card__item\" role=\"option\">" +
      "<a class=\"pma-predictive-product-card__link\" href=\"" + escapeHtml(url) + "\">" +
      "<div class=\"pma-predictive-product-card__media\">" + img + "</div>" +
      "<div class=\"pma-predictive-product-card__info\">" +
      "<span class=\"pma-predictive-product-card__title\">" + title + "</span>" +
      "<div class=\"pma-predictive-product-card__producer-wrap\"" + producerAttrs + ">" +
      "<p class=\"pma-producer-card__name\"><span class=\"pma-producer-card__label\">By </span>" +
      "<span class=\"pma-producer-card__name-text\">" + producerLabel + "</span></p></div>" +
      "<div class=\"pma-predictive-product-card__price-row\">" + priceHtml + "</div>" +
      "</div></a></article>"
    );
  }

  function buildItemHtml(item, type) {
    var url = item.url || "#";
    var title = escapeHtml(item.title || "");
    return (
      "<a class=\"pma-predictive-item pma-predictive-item--" + type + "\" href=\"" + escapeHtml(url) + "\" role=\"option\">" + title + "</a>"
    );
  }

  function buildShortcutHtml(query, label, url, type) {
    return (
      "<a class=\"pma-predictive-item pma-predictive-item--" + type + "\" href=\"" + escapeHtml(url) + "\" role=\"option\" data-pma-predictive-shortcut=\"" + type + "\">" +
      escapeHtml(label.replace("{{ query }}", query || "")) +
      "</a>"
    );
  }

  function buildShortcutSeparator() {
    return "<span class=\"pma-predictive-shortcut-separator\" role=\"presentation\" aria-hidden=\"true\">·</span>";
  }

  function buildTaxonomyShortcutHtml(shortcut, searchUrl) {
    var queryUrl = searchUrl + "?q=" + encodeURIComponent(shortcut.searchTerm) + "&type=product";
    return (
      "<a class=\"pma-predictive-item pma-predictive-item--taxonomy\" href=\"" + escapeHtml(shortcut.url) + "\" role=\"option\" data-pma-predictive-shortcut=\"taxonomy\" data-pma-taxonomy-group=\"" + escapeHtml(shortcut.key) + "\">" +
      "Browse " + escapeHtml(shortcut.label) +
      "</a>" +
      buildShortcutSeparator() +
      "<a class=\"pma-predictive-item pma-predictive-item--taxonomy-query\" href=\"" + escapeHtml(queryUrl) + "\" role=\"option\" data-pma-predictive-shortcut=\"taxonomy_query\" data-pma-taxonomy-group=\"" + escapeHtml(shortcut.key) + "\">" +
      "Search " + escapeHtml(shortcut.searchTerm) +
      "</a>"
    );
  }

  function summarizeResults(results) {
    var products = results.products || [];
    var articles = results.articles || [];
    var pages = results.pages || [];
    return {
      products: products,
      articles: articles,
      pages: pages,
      count: products.length + articles.length + pages.length,
    };
  }

  function render(results, query, searchUrl, placeholderUrl) {
    var viewAllUrl = searchUrl + "?q=" + encodeURIComponent(query);
    var html = "";
    html += "<a class=\"pma-predictive-view-all\" href=\"" + escapeHtml(viewAllUrl) + "\" role=\"option\">View all results</a>";

    var summary = summarizeResults(results);
    var products = summary.products;
    var articles = summary.articles;
    var pages = summary.pages;
    var encodedQuery = encodeURIComponent(query || "");
    var taxonomyShortcuts = getTaxonomyShortcuts(query);
    html += "<div class=\"pma-predictive-group pma-predictive-group--collections\" role=\"group\" aria-label=\"Collections\">";
    html += buildShortcutHtml(query, "Search products for \"{{ query }}\"", searchUrl + "?q=" + encodedQuery + "&type=product", "collection");
    html += buildShortcutSeparator();
    html += buildShortcutHtml(query, "Browse all products", "/collections/all", "collection");
    html += "</div>";
    if (taxonomyShortcuts.length) {
      html += "<div class=\"pma-predictive-group pma-predictive-group--taxonomy\" role=\"group\" aria-label=\"Related search paths\">";
      taxonomyShortcuts.forEach(function (shortcut, index) {
        if (index > 0) html += buildShortcutSeparator();
        html += buildTaxonomyShortcutHtml(shortcut, searchUrl);
      });
      html += "</div>";
    }
    html += "<div class=\"pma-predictive-group pma-predictive-group--producers\" role=\"group\" aria-label=\"Producers\">";
    html += buildShortcutHtml(query, "Find producers for \"{{ query }}\"", "/pages/producers?query=" + encodedQuery, "producer");
    html += "</div>";
    if (!summary.count) {
      html += "<p class=\"pma-predictive-empty\" role=\"status\">No matching suggestions yet. View all results for the full search page.</p>";
      return html;
    }

    if (isMemberActive() && products.length) {
      html += "<div class=\"pma-predictive-group pma-predictive-group--products\" role=\"group\" aria-label=\"Products\">";
      products.slice(0, 4).forEach(function (p) {
        var imgUrl = "";
        if (p.featured_image) {
          if (typeof p.featured_image === "string") imgUrl = p.featured_image;
          else if (p.featured_image.src) imgUrl = p.featured_image.src;
          else if (p.featured_image.url) imgUrl = p.featured_image.url;
        }
        p.featured_image = capShopifyImageWidth(imgUrl, PREDICTIVE_IMAGE_MAX);
        html += buildProductHtml(p, placeholderUrl);
      });
      html += "</div>";
    }

    if (articles.length) {
      html += "<div class=\"pma-predictive-group pma-predictive-group--articles\" role=\"group\" aria-label=\"Articles\">";
      articles.slice(0, 3).forEach(function (a) {
        html += buildItemHtml(a, "article");
      });
      html += "</div>";
    }

    if (pages.length) {
      html += "<div class=\"pma-predictive-group pma-predictive-group--pages\" role=\"group\" aria-label=\"Pages\">";
      pages.slice(0, 3).forEach(function (p) {
        html += buildItemHtml(p, "page");
      });
      html += "</div>";
    }

    return html;
  }

  function setup(container) {
    var input = container.querySelector('input[name="q"]');
    var resultsId = input.getAttribute("aria-controls");
    var resultsEl = resultsId ? document.getElementById(resultsId) : container.querySelector(".pma-predictive-results");
    var searchUrl = container.getAttribute("data-search-url") || "/search";
    var productPlaceholderUrl = container.getAttribute("data-product-placeholder-url") || "";
    if (!input || !resultsEl) return;

    var debounceTimer = null;
    var abortController = null;
    var visible = false;
    var openedThisSession = false;

    function setResultsState(state) {
      resultsEl.setAttribute("data-pma-predictive-state", state);
    }

    function show() {
      resultsEl.hidden = false;
      input.setAttribute("aria-expanded", "true");
      visible = true;
    }

    function hide() {
      resultsEl.hidden = true;
      input.setAttribute("aria-expanded", "false");
      setResultsState("idle");
      visible = false;
    }

    function fire(eventName, payload) {
      if (window.PMA && window.PMA.analytics && typeof window.PMA.analytics.track === "function") {
        window.PMA.analytics.track(eventName, payload);
      }
    }

    function fetchSuggest(q) {
      var cached = cacheGet(q);
      if (cached) {
        resultsEl.innerHTML = cached.html;
        setResultsState(cached.hasResults ? "results" : "empty");
        show();
        fire("search_typeahead_results", { query_length: q.slice(0, 200).length, results_count: cached.count });
        if (!cached.hasResults) {
          fire("pma_search_no_results", { query_length: q.slice(0, 200).length, search_ui: "predictive", results_count: 0 });
        }
        return Promise.resolve();
      }
      if (abortController) abortController.abort();
      abortController = new AbortController();
      setResultsState("loading");
      // SEC-031: In locked state, do not request product results to avoid price-bearing structures in network responses.
      var types = isMemberActive() ? "product,article,page" : "article,page";
      var params = "q=" + encodeURIComponent(q) + "&resources[type]=" + encodeURIComponent(types) + "&resources[limit]=4&resources[limit_scope]=each";
      return fetch(suggestUrl + "?" + params, { signal: abortController.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var results = (data.resources && data.resources.results) ? data.resources.results : {};
          var summary = summarizeResults(results);
          var rendered = render(results, q, searchUrl, productPlaceholderUrl);
          resultsEl.innerHTML = rendered;
          setResultsState(summary.count > 0 ? "results" : "empty");
          cacheSet(q, { html: rendered, count: summary.count, hasResults: summary.count > 0 });
          fire("search_typeahead_results", { query_length: q.slice(0, 200).length, results_count: summary.count });
          if (!summary.count) {
            fire("pma_search_no_results", { query_length: q.slice(0, 200).length, search_ui: "predictive", results_count: 0 });
          }
          if (!openedThisSession) {
            openedThisSession = true;
            fire("search_open", { query_length: q.slice(0, 200).length });
            fire("pma_search_open", { search_ui: "predictive", trigger: "typeahead" });
          }
          show();
        })
        .catch(function (err) {
          if (err.name !== "AbortError") {
            resultsEl.innerHTML = "";
            hide();
          }
        });
    }

    function onInput() {
      var q = (input.value || "").trim();
      if (q.length < 2) {
        resultsEl.innerHTML = "";
        hide();
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchSuggest(q);
      }, 300);
    }

    function onBlur() {
      setTimeout(function () {
        var active = document.activeElement;
        if (!container.contains(active)) hide();
      }, 150);
    }

    input.addEventListener("input", onInput);
    input.addEventListener("focus", function () {
      if ((input.value || "").trim().length >= 2 && resultsEl.innerHTML) {
        show();
        if (!openedThisSession) {
          openedThisSession = true;
          fire("search_open", { query_length: (input.value || "").trim().slice(0, 200).length });
          fire("pma_search_open", { search_ui: "predictive", trigger: "focus" });
        }
      }
    });
    input.addEventListener("blur", onBlur);

    function pathToHandle(href) {
      try {
        var path = (href && new URL(href, window.location.origin).pathname) || "";
        var parts = path.split("/").filter(Boolean);
        return parts.length ? parts[parts.length - 1] : "";
      } catch { return ""; }
    }

    resultsEl.addEventListener("click", function (e) {
      var link = e.target.closest("a");
      if (!link || !resultsEl.contains(link)) return;
      var term = (input.value || "").trim();
      var isViewAll = link.classList.contains("pma-predictive-view-all");
      var opts = resultsEl.querySelectorAll("[role=option]");
      var idx = Array.prototype.indexOf.call(opts, link.closest("[role=option]") || link);
      if (isViewAll) {
        fire("search_view_all_from_typeahead", { query_length: term.slice(0, 200).length });
        fire("pma_search_predictive_click", {
          result_type: "view_all",
          result_position: idx + 1,
          query_length: term.slice(0, 200).length
        });
      } else {
        var resourceType = "product";
        if (link.classList.contains("pma-predictive-item--article")) resourceType = "article";
        else if (link.classList.contains("pma-predictive-item--page")) resourceType = "page";
        else if (link.classList.contains("pma-predictive-item--collection")) resourceType = "collection";
        else if (link.classList.contains("pma-predictive-item--producer")) resourceType = "producer";
        var resourceId = link.getAttribute("data-resource-id") || "";
        fire("search_result_click", { query_length: term.slice(0, 200).length, position: idx + 1, resource_type: resourceType, resource_id: resourceId });
        fire("pma_search_result_click", {
          result_type: resourceType,
          result_position: idx + 1,
          query_length: term.slice(0, 200).length,
          resource_handle: pathToHandle(link.getAttribute("href") || link.href)
        });
        fire("pma_search_predictive_click", {
          result_type: resourceType,
          result_position: idx + 1,
          query_length: term.slice(0, 200).length,
          resource_handle: pathToHandle(link.getAttribute("href") || link.href)
        });
      }
    });

    input.addEventListener("keydown", function (e) {
      if (!visible) return;
      var opts = Array.prototype.slice.call(resultsEl.querySelectorAll("[role=\"option\"]"), 0);
      var current = document.activeElement;
      var idx = opts.indexOf(current);
      if (e.key === "Escape") {
        hide();
        input.focus();
        e.preventDefault();
        return;
      }
      if (e.key === "ArrowDown") {
        if (idx < opts.length - 1) opts[idx + 1].focus();
        else if (opts.length) opts[0].focus();
        e.preventDefault();
      }
      if (e.key === "ArrowUp") {
        if (idx > 0) opts[idx - 1].focus();
        else if (opts.length) opts[opts.length - 1].focus();
        e.preventDefault();
      }
      if (e.key === "Enter") {
        if (current && opts.indexOf(current) >= 0) {
          var link = current.querySelector ? current.querySelector("a") : null;
          if (!link && current.tagName === "A") link = current;
          if (link && link.href) {
            e.preventDefault();
            window.location.href = link.href;
          }
        }
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && visible) {
        hide();
        input.focus();
      }
    });
  }

  function fireSearchAnalytics(eventName, payload) {
    if (window.PMA && window.PMA.analytics && typeof window.PMA.analytics.track === "function") {
      window.PMA.analytics.track(eventName, payload);
    }
  }

  function stripHtmlText(html) {
    if (!html) return "";
    var div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || div.innerText || "").trim();
  }

  function truncateText(text, max) {
    if (!text || text.length <= max) return text || "";
    return text.slice(0, max - 3) + "...";
  }

  function buildBoostArticleCard(article) {
    var url = article.url || "#";
    var title = escapeHtml(article.title || "");
    var excerpt = escapeHtml(truncateText(stripHtmlText(article.body || article.summary || ""), 120));
    var blogLabel = article.blog && article.blog.title
      ? escapeHtml(article.blog.title)
      : (article.blog ? escapeHtml(String(article.blog)) : "Article or guide");
    return (
      "<article class=\"pma-card\" data-pma-search-resource-type=\"article\" data-pma-search-all-boost=\"article\">" +
      "<p class=\"pma-muted pma-text-sm\">" + blogLabel + "</p>" +
      "<h3><a href=\"" + escapeHtml(url) + "\">" + title + "</a></h3>" +
      "<p>" + excerpt + "</p></article>"
    );
  }

  function buildBoostPageCard(page) {
    var url = page.url || "#";
    var title = escapeHtml(page.title || "");
    var excerpt = escapeHtml(truncateText(stripHtmlText(page.body || page.summary || ""), 120));
    return (
      "<article class=\"pma-card\" data-pma-search-resource-type=\"page\" data-pma-search-all-boost=\"page\">" +
      "<p class=\"pma-muted pma-text-sm\">Site page</p>" +
      "<h3><a href=\"" + escapeHtml(url) + "\">" + title + "</a></h3>" +
      "<p>" + excerpt + "</p></article>"
    );
  }

  function initAllScopeBoost() {
    var host = document.querySelector("[data-pma-search-all-boost]");
    if (!host) return;
    var query = (host.getAttribute("data-search-query") || "").trim();
    var loadingEl = host.querySelector("[data-pma-search-all-boost-loading]");
    var contentEl = host.querySelector("[data-pma-search-all-boost-content]");
    if (!contentEl || query.length < 2) {
      host.setAttribute("data-pma-search-all-boost-state", "empty");
      if (loadingEl) loadingEl.hidden = true;
      return;
    }
    query = resolveCanonicalSearchQuery(query) || query;

    host.setAttribute("data-pma-search-all-boost-state", "loading");
    host.setAttribute("aria-busy", "true");
    var types = "article,page";
    var params = "q=" + encodeURIComponent(query) + "&resources[type]=" + encodeURIComponent(types) + "&resources[limit]=8&resources[limit_scope]=each";

    fetch(suggestUrl + "?" + params)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var results = (data.resources && data.resources.results) ? data.resources.results : {};
        var articles = results.articles || [];
        var pages = results.pages || [];
        var html = "";
        var articlesHeading = (window.PMA && window.PMA.i18n && window.PMA.i18n.search_boost_articles_heading) || "Guides & articles";
        var pagesHeading = (window.PMA && window.PMA.i18n && window.PMA.i18n.search_boost_pages_heading) || "Pages";

        if (articles.length) {
          html += "<h3 class=\"pma-search-group-heading\">" + escapeHtml(articlesHeading) + "</h3>";
          html += "<div class=\"pma-grid pma-grid--3 pma-mb-6\">";
          articles.forEach(function (article) {
            html += buildBoostArticleCard(article);
          });
          html += "</div>";
        }
        if (pages.length) {
          html += "<h3 class=\"pma-search-group-heading\">" + escapeHtml(pagesHeading) + "</h3>";
          html += "<div class=\"pma-grid pma-grid--3 pma-mb-6\">";
          pages.forEach(function (page) {
            html += buildBoostPageCard(page);
          });
          html += "</div>";
        }

        if (html) {
          contentEl.innerHTML = html;
          contentEl.hidden = false;
          host.setAttribute("data-pma-search-all-boost-state", "ready");
          var fallback = document.querySelector("[data-pma-search-all-liquid-knowledge]");
          if (fallback) fallback.hidden = true;
          fireSearchAnalytics("pma_search_all_boost_ready", { query_length: query.slice(0, 200).length, results_count: articles.length + pages.length });
        } else {
          host.setAttribute("data-pma-search-all-boost-state", "empty");
        }
        if (loadingEl) loadingEl.hidden = true;
        host.setAttribute("aria-busy", "false");
      })
      .catch(function () {
        host.setAttribute("data-pma-search-all-boost-state", "error");
        if (loadingEl) loadingEl.hidden = true;
        host.setAttribute("aria-busy", "false");
      });
  }

  function buildLockedProductDiscovery(query, productsUrl, searchUrl) {
    var html = "";
    var heading = (window.PMA && window.PMA.i18n && window.PMA.i18n.search_boost_products_heading) || "Shop products";
    var searchProductsLabel = (window.PMA && window.PMA.i18n && window.PMA.i18n.all_scope_discovery_products) || "Search products for this query";
    var browseAllLabel = (window.PMA && window.PMA.i18n && window.PMA.i18n.all_scope_discovery_browse) || "Browse all products";
    html += "<h3 class=\"pma-search-group-heading\">" + escapeHtml(heading) + "</h3>";
    html += "<nav class=\"pma-search-all-discovery pma-mb-4\" aria-label=\"Product discovery\">";
    html += "<p class=\"pma-search-all-discovery__links\">";
    html += "<a class=\"pma-link\" href=\"" + escapeHtml(productsUrl) + "\">" + escapeHtml(searchProductsLabel) + "</a>";
    html += "<span class=\"pma-search-all-discovery__sep\" aria-hidden=\"true\"> · </span>";
    html += "<a class=\"pma-link\" href=\"/collections/all\">" + escapeHtml(browseAllLabel) + "</a>";
    html += "</p>";
    var shortcuts = getTaxonomyShortcuts(query);
    if (shortcuts.length) {
      html += "<ul class=\"pma-search-all-discovery__taxonomy\">";
      shortcuts.forEach(function (shortcut) {
        var queryUrl = searchUrl + "?q=" + encodeURIComponent(shortcut.searchTerm) + "&type=product";
        html += "<li class=\"pma-search-all-discovery__taxonomy-item\">";
        html += "<a class=\"pma-link\" href=\"" + escapeHtml(shortcut.url) + "\">Browse " + escapeHtml(shortcut.label) + "</a>";
        html += "<span class=\"pma-search-all-discovery__sep\" aria-hidden=\"true\"> · </span>";
        html += "<a class=\"pma-link\" href=\"" + escapeHtml(queryUrl) + "\">Search " + escapeHtml(shortcut.searchTerm) + "</a>";
        html += "</li>";
      });
      html += "</ul>";
    }
    html += "</nav>";
    return html;
  }

  function initAllScopeProductBoost() {
    var host = document.querySelector("[data-pma-search-all-product-boost]");
    if (!host) return;
    var query = (host.getAttribute("data-search-query") || "").trim();
    var loadingEl = host.querySelector("[data-pma-search-all-product-boost-loading]");
    var contentEl = host.querySelector("[data-pma-search-all-product-boost-content]");
    var productsUrl = host.getAttribute("data-products-url") || "";
    var searchUrl = host.getAttribute("data-search-url") || "/search";
    var placeholderUrl = host.getAttribute("data-product-placeholder-url") || "";
    var liquidProducts = document.querySelector("[data-pma-search-all-liquid-products]");
    var liquidCta = document.querySelector("[data-pma-search-all-products-cta]");
    if (!contentEl || query.length < 2) {
      host.setAttribute("data-pma-search-all-product-boost-state", "empty");
      if (loadingEl) loadingEl.hidden = true;
      return;
    }
    query = resolveCanonicalSearchQuery(query) || query;

    host.setAttribute("data-pma-search-all-product-boost-state", "loading");
    host.setAttribute("aria-busy", "true");

    function finish(state, html, hideLiquid) {
      if (html) {
        contentEl.innerHTML = html;
        contentEl.hidden = false;
      }
      host.setAttribute("data-pma-search-all-product-boost-state", state);
      if (loadingEl) loadingEl.hidden = true;
      host.setAttribute("aria-busy", "false");
      if (hideLiquid && liquidProducts) liquidProducts.hidden = true;
      if (hideLiquid && liquidCta) liquidCta.hidden = true;
    }

    if (!isMemberActive()) {
      finish("ready", buildLockedProductDiscovery(query, productsUrl, searchUrl), false);
      fireSearchAnalytics("pma_search_all_product_discovery_ready", { query_length: query.slice(0, 200).length, locked: true });
      return;
    }

    var params = "q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=8&resources[limit_scope]=each";
    fetch(suggestUrl + "?" + params)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var results = (data.resources && data.resources.results) ? data.resources.results : {};
        var products = results.products || [];
        if (!products.length) {
          finish("empty", "", false);
          return;
        }
        var heading = (window.PMA && window.PMA.i18n && window.PMA.i18n.search_boost_products_heading) || "Shop products";
        var ctaLabel = (window.PMA && window.PMA.i18n && window.PMA.i18n.all_scope_products_cta) || "View all product results for this search";
        var html = "<h3 class=\"pma-search-group-heading\">" + escapeHtml(heading) + "</h3>";
        html += "<div class=\"pma-search-all-product-grid pma-grid pma-grid--3 pma-mb-4\">";
        products.forEach(function (product) {
          html += buildProductHtml(product, placeholderUrl);
        });
        html += "</div>";
        if (productsUrl) {
          html += "<p class=\"pma-search-all-scope-hint pma-mb-4\"><a class=\"pma-link\" href=\"" + escapeHtml(productsUrl) + "\">" + escapeHtml(ctaLabel) + "</a></p>";
        }
        finish("ready", html, true);
        fireSearchAnalytics("pma_search_all_product_boost_ready", { query_length: query.slice(0, 200).length, results_count: products.length });
      })
      .catch(function () {
        finish("error", buildLockedProductDiscovery(query, productsUrl, searchUrl), false);
      });
  }

  function init() {
    try {
      initAllScopeBoost();
      initAllScopeProductBoost();
      qsa("[data-pma-predictive-search]").forEach(function (el) {
        try {
          setup(el);
        } catch (err) {
          try {
            document.dispatchEvent(new CustomEvent("pma:observability", {
              detail: { kind: "error", error_type: "predictive_search_setup", message: (err && err.message) || String(err) },
              bubbles: true
            }));
          } catch (e) { void e; }
        }
      });
    } catch (err) {
      try {
        document.dispatchEvent(new CustomEvent("pma:observability", {
          detail: { kind: "error", error_type: "predictive_search_init", message: (err && err.message) || String(err) },
          bubbles: true
        }));
      } catch (e) { void e; }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      installSearchFormCanonicalization();
      init();
    });
  } else {
    installSearchFormCanonicalization();
    init();
  }
})();
